/*
  Product fit scale animation
  Keeps behavior minimal: validate the Liquid value, then allow CSS to animate the dot.
*/

(function () {
  function initFitScale(scale) {
    var value = Number(scale.dataset.fitValue);
    var clampedValue = Math.min(100, Math.max(0, Number.isFinite(value) ? value : 50));

    scale.style.setProperty('--pf-fit-value', clampedValue);

    requestAnimationFrame(function () {
      scale.classList.add('is-ready');
    });
  }

  function initAllFitScales() {
    document.querySelectorAll('[data-fit-scale]').forEach(initFitScale);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFitScales);
  } else {
    initAllFitScales();
  }
})();
